'use client';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

// Register plugins once on client side only
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger, useGSAP);

  // Global configuration (same as original App.tsx)
  ScrollTrigger.config({
    limitCallbacks: true,
    ignoreMobileResize: true,
  });

  gsap.config({
    force3D: true,
  });
}

export { gsap, ScrollTrigger, useGSAP };
